import React from 'react';
import { Container, Row, Col, Card, Progress, Button, CardTitle, CardImg, CardText } from 'reactstrap';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const MissionsPanel = (props) => {

  const { tenantConfig, size, name, metaDescription, tagLine, description, imgUrlPath,
    imgUrl, imgAlt, buttonText, graphicText, target, monthly_supporters, percentage_reached, targetText, readmore } = props;


  const number = percentage_reached;
  const percent = (Math.round(number, -2));


  const graphictextmissions = graphicText.map((item, index) => (
    <Col xs={6} md={4} lg={4} key={index}>
      <div>
        <img style={{ width: '65%'}} className="missions-panel-right-icons"
          src={item.thumbnail} alt="" />
        <h3 className="text-center missions-panel-right-icons-heading ">{item.middletext}</h3>
        <p className="">{item.text}</p>
      </div>
    </Col>
  ));

  return (
		<Container fluid style={{ padding: '0px' }} className="missions-panel-box">
			<Container>
				<div style={{ marginTop: '1rem' }}>
					<div
						className="missions-inner-panel missions-panel-mobile"
						style={{}}
					>
						<Row className="missions-panel-outer-box">
							<Col {...size.left} className="missions-panel-mobile">
								<div className="justify-content-center align-self-center">
									<div className="hide-for-desktop">
										<h2 className="missions-panel-right-heading">{tagLine}</h2>
										<p>{metaDescription}</p>
									</div>
									<Col className="missions-panel-mobile">
										<Card>
											<img
												style={{ width: '100%' }}
												src={`${config.cdnUrl}${imgUrlPath}${imgUrl}`}
												alt={imgAlt}
												className="gi-background-image"
											/>
											<div className="card-inner-content">
												<CardTitle>
													<h3>{name}</h3>{' '}
												</CardTitle>
												<CardText>{description}</CardText>
											</div>
											<div className="progress-wrapper card-process-wrapper-content">
												<div className="" style={{ paddingBottom: '10px' }}>
													<span className="supporting-card-bold-text">
														{target} {targetText}
													</span>
												</div>
												<Progress
													className="supporter-process-bar"
													value={percentage_reached}
												/>
												<div
													style={{ paddingTop: '10px', paddingBottom: '10px' }}
												>
													<span>
														<span className="monthly-count-supporters">
															{monthly_supporters}
														</span>{' '}
														supporters needed
													</span>
													<span className="completed-supporters">
														{percent}%{' '}
													</span>
												</div>
											</div>
										</Card>
									</Col>
								</div>
							</Col>
							<Col {...size.right} className="right-side-panel-mobile">
								<div>
									<div className="hide-for-mobile">
										<h2 className="missions-panel-right-heading">{tagLine}</h2>
										<p>{metaDescription}</p>
									</div>
									<div
										className="hide-for-mobile"
										style={{ paddingTop: '2rem', paddingBottom: '2rem' }}
									>
										<Row>{graphictextmissions}</Row>
									</div>

									<Row>
										<Col
											xs="12"
											sm="12"
											md="6"
											lg="6"
											className="campaign-btn-mobile"
										>
											<a
												href={`/missions/${readmore}`}
												onClick={() => {
													if (window.eventDispatcher) {
														window.eventDispatcher.dispatchEventSync(
															'missions-btn',
															{},
															{ amplitude: true }
														);
													}
												}}
											>
												<Button
													style={{ width: '100%' }}
													color={tenantConfig.theme.primaryCTA.backgroundColor}
													className="btn btn-primary "
												>
													{' '}
													{buttonText}
												</Button>
											</a>
										</Col>

										{/* <Col xs="12" sm="12" md="6" lg="6" className="" style={{ padding: '5px' }}>
                      <a href={(`/missions/${readmore}`)} className="missions-panel-right-readmore"
                        onClick={() => {
                          if (window.eventDispatcher) {
                            window.eventDispatcher.dispatchEventSync('missions-readmore', {}, { amplitude: true });
                          }
                        }}
                      >readmore
                              <svg
                          viewBox="0 0 18 18"
                          role="presentation"
                          aria-hidden="true"
                          focusable="false"
                          style={{ height: '10px', width: '10px', fill: 'currentcolor', marginLeft: '1rem' }}
                        >
                          <path

                            style={{ background: '#FFF' }}
                            d="m4.29 1.71a1 1 0 1 1 1.42-1.41l8 8a1 1 0 0 1 0 1.41l-8 8a1 1 0 1 1 -1.42-1.41l7.29-7.29z"
                            fillRule="evenodd"
                          />
                        </svg></a>
                    </Col> */}
									</Row>
								</div>
							</Col>
						</Row>
					</div>
				</div>
			</Container>
			<style global jsx>
				{`
					.image-card-top {
						border-style: none;
					}
					.card-inner-content {
						padding-top: 1rem;
						padding-right: 1rem;
						// padding-bottom: 1rem;
						padding-left: 1rem;
					}
					.card-process-wrapper-content {
						padding-top: 1rem;
						padding-right: 1rem;
						padding-bottom: 1rem;
						padding-left: 1rem;
					}
					.card-price {
						margin-bottom: 10px;
					}
					.card-price h6 {
						margin-bottom: 0;
						font-weight: 600;
					}
					.tag-row {
						margin-bottom: 10px;
					}
					.giveassured-position {
						position: absolute;
						bottom: 3px;
						right: 3px;
						background: white;
						padding: 1px 5px;
						border-radius: 5px;
						box-shadow: 0 2px 2px rgba(50, 50, 93, 0),
							0 1px 2px rgba(0, 0, 0, 0.08);
					}
					.supporting-card-bold-text {
						font-weight: 600;
						font-size: 18px;
						color: #444444;
					}
					.supporter-process-bar.progress {
						height: 8px !important;
					}
					.supporter-process-bar .progress-bar {
						background: #ff5050 !important;
					}
					.completed-supporters {
						float: right;
						color: #666666 !important;
					}
					.monthly-count-supporters {
						color: #666666 !important;
					}
					.missions-panel-box {
						background-image: url('https://give-marketplace-dev.s3.ap-south-1.amazonaws.com/static/images/home/homev2/mission-banner/missions-bg-desktop.jpg');
						// background-color: red;
						height: 100%;
						// opacity: 0.5;
					}
					.missions-card .card {
						width: 22rem;
					}
					.missions-panel-btn {
						height: 50px !important;
						font-size: 1.25rem;
					}
					@media (max-width: 576px) {
						.missions-panel-mobile {
							padding: 0px;
						}
						.campaign-btn-mobile {
							padding: 0px !important;
						}
						.right-side-panel-mobile {
							padding-right: 0px;
							padding-left: 05px;
						}
					}
					.missions-panel-right-icons {
						display: block;
						margin-left: auto;
						margin-right: auto;
					}
					.missions-panel-right-icons-heading {
						font-size: 34px;
					}
					.missions-panel-right-readmore {
						display: inline;
						padding-left: 2rem;
					}
					.missions-panel-outer-box {
						padding-top: 2rem;
						padding-bottom: 2rem;
					}
					@media (max-width: 768px) {
						.missions-panel-right-readmore {
							text-align: center !important;
							display: block;
							padding-top: 1rem;
						}
						.missions-panel-outer-box {
							padding-top: 1rem;
							padding-bottom: 0rem;
						}
					}
				`}
			</style>
		</Container>
	);
};


MissionsPanel.defaultProps = {
  className: 'gi-campaign-panel d-flex',
  title: 'mission 10 million meals',
  description: 'Join 123 people who have pledged to help our trusted NGO partners make a difference in the lives of countless children by providing them with daily mid day meals.',
  needed: 1270,
  completed: 80,
  size: {
    left: {
      xs: 12,
      sm: 12,
      md: '8',
      lg: '5',
      xl: '5',
    },
    right: {
      xs: 12,
      sm: 12,
      md: '8',
      lg: '7',
      xl: '7',
    },
  },
  tags: [
    {
      type: 'extremeneed',
      design: 'capsule',
    },
  ],
  image: '/static/images/campaign/target-image1.jpg',
  partnerImage: '/static/images/campaign/mission-partner-ngo.png',
  link: '#'
};

export default MissionsPanel;
